//  @flow
/* ---------------- Globals --------------*/
import { combineReducers } from 'redux';

/* ---------------- Reducers --------------*/
import choiceReducer from '../../../../multichoice/reducer';
import folderReducer from '../../../../folder/reducer';
import flipReducer from '../../../../flip/reducer';
import matchReducer from '../../../../match/reducer';
import studySetReducer from '../../../../studyset/reducer';
import searchReducer from '../../../../search/reducer';
import createScheduleReducer from '../../../../schedule/reducer';
import chromeHeaderReducer from '../../../../chrome/reducer';
import createReducer from '../../../../create/redux/reducer';
import storeReducer from '../../../../store/reducer';

/* ---------------- Root reducer --------------*/
// TODO: Eliminate global store. Make stores app level.
const appReducer = combineReducers({
  choiceReducer,
  folderReducer,
  flipReducer,
  matchReducer,
  studySetReducer,
  searchReducer,
  createScheduleReducer,
  chromeHeaderReducer,
  createReducer,
  storeReducer,
});

export default appReducer;
